export const pricing = [
  {
    type: "yearly",
    is_promo: true,
    text_promo: "Hemat 990 ribu!",
    data: [
      {
        title: "accounting_only",
        price: "IDR 32.400.000*",
        old_price: "IDR 36.000.000",
        discount: "bookeeping_service_discount",
        is_populer: false,
        description: "bookeeping_service_desc",
        list: [
          {
            name: "bookeeping_service_list_one",
            active: true,
            subname: "",
          },
          {
            name: "bookeeping_service_list_two",
            active: true,
            subname: "",
          },
          {
            name: "bookeeping_service_list_three",
            active: true,
            subname: "",
          },
          {
            name: "bookeeping_service_list_four",
            active: true,
            subname: "",
          },
          {
            name: "bookeeping_service_list_five",
            active: false,
            subname: "",
          },
          {
            name: "Formulir 1721 - A1",
            subname: "bookeeping_service_list_six",
            active: false,
          },
          {
            name: "bookeeping_service_list_seven",
            active: false,
            subname: "",
          },
        ],
      },
      {
        title: "bookeeping_tax",
        price: "IDR 70.200.000*",
        old_price: "IDR 78.000.000",
        discount: "bookeeping_service_tax_discont",
        is_populer: true,
        description: "bookeeping_service_tax_desc",
        list: [
          {
            name: "bookeeping_service_list_one",
            active: true,
            subname: "",
          },
          {
            name: "bookeeping_service_list_two",
            active: true,
            subname: "",
          },
          {
            name: "bookeeping_service_list_three",
            subname: "",
            active: true,
          },
          {
            name: "bookeeping_service_list_four",
            subname: "",
            active: true,
          },
          {
            name: "bookeeping_service_list_five",
            active: true,
          },
          {
            name: "Formulir 1721 - A1",
            subname: "bookeeping_service_list_six",
            active: true,
          },
          {
            name: "bookeeping_service_list_seven",
            subname: "",
            active: true,
          },
        ],
      },
    ],
  },
  {
    type: "monthly",
    is_promo: false,
    text_promo: "Hemat 990 ribu!",
    data: [
      {
        title: "accounting_only",
        price: "IDR 3.000.000",
        is_populer: false,
        old_price: "",
        discount: "",
        description: "bookeeping_service_desc",
        list: [
          {
            name: "bookeeping_service_list_one",
            active: true,
            subname: "",
          },
          {
            name: "bookeeping_service_list_two",
            active: true,
            subname: "",
          },
          {
            name: "bookeeping_service_list_three",
            active: true,
            subname: "",
          },
          {
            name: "bookeeping_service_list_four",
            active: true,
            subname: "",
          },
          {
            name: "bookeeping_service_list_five",
            active: false,
            subname: "",
          },
          {
            name: "Formulir 1721 - A1",
            subname: "bookeeping_service_list_six",
            active: false,
          },
          {
            name: "bookeeping_service_list_seven",
            active: false,
            subname: "",
          },
        ],
      },
      {
        title: "bookeeping_tax",
        price: "IDR 6.500.000*",
        is_populer: true,
        discount: "",
        old_price: "",
        description: "bookeeping_service_tax_desc",
        list: [
          {
            name: "bookeeping_service_list_one",
            active: true,
            subname: "",
          },
          {
            name: "bookeeping_service_list_two",
            active: true,
            subname: "",
          },
          {
            name: "bookeeping_service_list_three",
            subname: "",
            active: true,
          },
          {
            name: "bookeeping_service_list_four",
            subname: "",
            active: true,
          },
          {
            name: "bookeeping_service_list_five",
            active: true,
          },
          {
            name: "Formulir 1721 - A1",
            subname: "bookeeping_service_list_six",
            active: true,
          },
          {
            name: "bookeeping_service_list_seven",
            subname: "",
            active: true,
          },
        ],
      },
    ],
  },
];
